import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegistrationPending = ({ registrationStatus }) => {
  const location = useLocation();
  const email = location.state?.email || 'your email';
  const isRejected = registrationStatus === 'rejected';

  return (
    <div className='min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col items-center justify-center p-4'>
      <div className='max-w-md w-full bg-white dark:bg-slate-900 rounded-3xl shadow-enterprise border border-slate-200 dark:border-slate-800 p-8 text-center'>
        <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 ${
          isRejected ? 'bg-destructive/10 text-destructive' : 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400'
        }`}>
          <Icon name={isRejected ? 'XCircle' : 'Clock'} size={40} />
        </div>
        
        <h1 className='text-2xl font-bold text-slate-800 dark:text-white mb-4'>
          {isRejected ? 'Request Rejected' : 'Approval Pending'}
        </h1>
        
        <p className='text-slate-600 dark:text-slate-400 mb-8'>
          {isRejected 
            ? 'Your request to join the organization has been rejected by the administrator. Please contact your organization owner for more information.' 
            : 'Your request to join the organization has been submitted successfully. The organization administrators have been notified and need to approve your request before you can access the workspace.'
          }
        </p>

        {!isRejected && (
          <div className='bg-slate-50 dark:bg-slate-800/50 rounded-2xl p-4 mb-8 text-sm text-left'>
            <div className='flex items-center gap-3 text-slate-700 dark:text-slate-300 mb-2 font-semibold'>
              <Icon name='Info' size={16} />
              Next Steps
            </div>
            <ul className='space-y-2 text-slate-500 dark:text-slate-400 list-disc pl-5'>
              <li>Wait for an email notification regarding your approval.</li>
              <li>Check back here later to access your dashboard.</li>
              <li>Contact your organization admin if you need immediate access.</li>
            </ul>
          </div>
        )}

        <div className='space-y-3'>
          {!isRejected && (
            <Button 
              className='w-full'
              onClick={() => window.location.reload()}
              variant='outline'
            >
              Refresh Status
            </Button>
          )}
          <Link to='/login' className='block'>
            <Button variant={isRejected ? 'default' : 'ghost'} className='w-full'>
              {isRejected ? 'Back to Sign In' : 'Back to Sign In'}
            </Button>
          </Link>
        </div>
      </div>
      
      <p className='mt-8 text-slate-400 dark:text-slate-600 text-sm'>
        Signed up as <span className='font-semibold text-slate-600 dark:text-slate-300'>{email}</span>
      </p>
    </div>
  );
};

export default RegistrationPending;
